import React from "react";
import { ManageRetirementContainer } from "../../../containers";

const ManageRetirement = (props) => {
  return <ManageRetirementContainer {...props} />;
};

export default ManageRetirement;
